<div class="counselling-photo-gallery-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title>
      <mat-icon>photo_library</mat-icon>
      Education Session Documents
    </h2>
    <div class="header-actions" *ngIf="documents.length > 0">
      <button mat-raised-button color="accent" *ngIf="!selectionMode" (click)="toggleSelectionMode()">
        <mat-icon>check_circle</mat-icon>
        Select Images
      </button>
      <button mat-raised-button color="primary" *ngIf="selectionMode"
              [disabled]="selectedDocuments.length === 0"
              (click)="confirmSelection()">
        <mat-icon>done</mat-icon>
        Confirm ({{selectedDocuments.length}})
      </button>
      <button mat-button *ngIf="selectionMode" (click)="cancelSelection()">
        <mat-icon>cancel</mat-icon>
        Cancel
      </button>
    </div>
  </div>

  <div class="dialog-content">
    <!-- Filters Section -->
    <div class="filters-section">
      <div class="row">
        <!-- Centre Selection -->
        <div class="col-md-4">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Centre</mat-label>
            <mat-select [(ngModel)]="selectedCentre">
              <mat-option value="All">All Centres</mat-option>
              <mat-option *ngFor="let centre of centres$ | async" [value]="centre.centreCode">
                {{ centre.centreName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Session Type -->
        <div class="col-md-4">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Session Type</mat-label>
            <mat-select [(ngModel)]="selectedSessionType">
              <mat-option value="All">All Session Types</mat-option>
              <mat-optgroup label="── Individual ──">
                <mat-option value="Rapport Building">Rapport Building</mat-option>
                <mat-option value="Baseline Assessment">Baseline Assessment</mat-option>
                <mat-option value="Intermediate Assessment">Intermediate Assessment</mat-option>
                <mat-option value="Discharge Assessment">Discharge Assessment</mat-option>
                <mat-option value="Regular Study">Regular Study</mat-option>
              </mat-optgroup>
              <mat-optgroup label="── Group ──">
                <mat-option value="Regular Study">Regular Study</mat-option>
                <mat-option value="Activity Session">Activity Session</mat-option>
                <mat-option value="Special Day">Special Day</mat-option>
              </mat-optgroup>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Date Range -->
        <div class="col-md-2">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Start Date</mat-label>
            <input matInput [matDatepicker]="startPicker" [(ngModel)]="startDate">
            <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="col-md-2">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>End Date</mat-label>
            <input matInput [matDatepicker]="endPicker" [(ngModel)]="endDate">
            <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="row">
        <div class="col-md-12 text-right">
          <button mat-raised-button color="primary" (click)="loadDocuments()" [disabled]="!startDate || !endDate || isLoading">
            <mat-icon>search</mat-icon>
            Search
          </button>
          <button mat-raised-button (click)="clearFilters()" class="ml-2">
            <mat-icon>clear</mat-icon>
            Clear
          </button>
        </div>
      </div>
    </div>

    <!-- Loading Spinner -->
    <div *ngIf="isLoading" class="loading-container">
      <mat-spinner></mat-spinner>
      <p>Loading documents...</p>
    </div>

    <!-- Results Summary -->
    <div *ngIf="!isLoading && documents.length > 0" class="results-summary">
      <div class="summary-info">
        <mat-chip-list>
          <mat-chip color="primary" selected>
            <mat-icon>photo</mat-icon>
            {{ documents.length }} Document(s) Found
          </mat-chip>
          <mat-chip *ngIf="selectedDocuments.length > 0" color="accent" selected>
            <mat-icon>check_circle</mat-icon>
            {{ selectedDocuments.length }} Selected
          </mat-chip>
        </mat-chip-list>
      </div>

      <div class="action-buttons">
        <button mat-icon-button (click)="selectAll()" matTooltip="Select All" *ngIf="selectedDocuments.length === 0 && selectionMode">
          <mat-icon>select_all</mat-icon>
        </button>
        <button mat-icon-button (click)="deselectAll()" matTooltip="Deselect All" *ngIf="selectedDocuments.length > 0 && selectionMode">
          <mat-icon>clear</mat-icon>
        </button>
        <button mat-icon-button (click)="toggleViewMode()" [matTooltip]="viewMode === 'grid' ? 'Switch to List' : 'Switch to Grid'">
          <mat-icon>{{ viewMode === 'grid' ? 'view_list' : 'view_module' }}</mat-icon>
        </button>
      </div>
    </div>

    <!-- No Results Message -->
    <div *ngIf="!isLoading && documents.length === 0 && (startDate && endDate)" class="no-results">
      <mat-icon>image_not_supported</mat-icon>
      <p>No documents found for the selected filters</p>
    </div>

    <!-- Documents Grid/List -->
    <div *ngIf="!isLoading && documents.length > 0"
         class="documents-container"
         [class.grid-view]="viewMode === 'grid'"
         [class.list-view]="viewMode === 'list'">
      <mat-card *ngFor="let doc of documents"
                class="document-card"
                [class.selected]="doc.selected"
                [class.list-item]="viewMode === 'list'">

        <!-- Checkbox Overlay (shown in selection mode) -->
        <div class="selection-checkbox" *ngIf="selectionMode">
          <mat-checkbox
            [checked]="doc.selected"
            (click)="$event.stopPropagation()"
            (change)="toggleSelection(doc)">
          </mat-checkbox>
        </div>

        <!-- Image/File Preview -->
        <mat-card-content class="document-preview" (click)="viewMode === 'grid' && !selectionMode ? openImage(doc.url) : toggleSelection(doc)">
          <div class="preview-container">
            <!-- Image Preview -->
            <img *ngIf="isImage(doc.url)"
                 [src]="doc.url"
                 [alt]="doc.fileName"
                 class="preview-image"
                 loading="lazy">

            <!-- PDF Preview -->
            <div *ngIf="isPdf(doc.fileName)" class="file-icon-container">
              <mat-icon class="file-icon pdf-icon">picture_as_pdf</mat-icon>
              <p class="file-type-label">PDF</p>
            </div>

            <!-- Other File Types -->
            <div *ngIf="!isImage(doc.url) && !isPdf(doc.fileName)" class="file-icon-container">
              <mat-icon class="file-icon">insert_drive_file</mat-icon>
              <p class="file-type-label">FILE</p>
            </div>

            <!-- Selection Overlay -->
            <div class="selection-overlay" *ngIf="doc.selected">
              <mat-icon class="check-icon">check_circle</mat-icon>
            </div>
          </div>
        </mat-card-content>

        <!-- Document Info -->
        <mat-card-actions class="document-info">
          <div class="info-row">
            <mat-icon class="info-icon">description</mat-icon>
            <span class="info-text" [matTooltip]="doc.description || doc.fileName">{{ doc.description || doc.fileName }}</span>
          </div>

          <div class="info-row" *ngIf="doc.centreName">
            <mat-icon class="info-icon">location_on</mat-icon>
            <span class="info-text" [matTooltip]="doc.centreName">{{ doc.centreName }}</span>
          </div>

          <div class="info-row" *ngIf="doc.sessionType">
            <mat-icon class="info-icon">category</mat-icon>
            <span class="info-text">{{ doc.sessionType }}</span>
          </div>

          <div class="info-row" *ngIf="doc.date">
            <mat-icon class="info-icon">calendar_today</mat-icon>
            <span class="info-text">{{ formatDate(doc.date) }}</span>
          </div>

          <!-- Action Buttons -->
          <div class="action-buttons">
            <button mat-icon-button
                    (click)="openImage(doc.url); $event.stopPropagation()"
                    matTooltip="Open in new tab">
              <mat-icon>open_in_new</mat-icon>
            </button>
            <button mat-icon-button
                    (click)="downloadImage(doc.url, doc.fileName); $event.stopPropagation()"
                    matTooltip="Download">
              <mat-icon>download</mat-icon>
            </button>
          </div>
        </mat-card-actions>

        <!-- File Name Footer -->
        <div class="file-name" [matTooltip]="doc.fileName">
          {{ doc.fileName }}
        </div>
      </mat-card>
    </div>
  </div>

  <mat-dialog-actions align="end">
    <button mat-button (click)="closeDialog()" *ngIf="!selectionMode">
      <mat-icon>close</mat-icon>
      Close
    </button>
    <button mat-button (click)="cancelSelection()" *ngIf="selectionMode">
      <mat-icon>cancel</mat-icon>
      Cancel
    </button>
    <button mat-raised-button color="primary"
            (click)="confirmSelection()"
            *ngIf="selectionMode"
            [disabled]="selectedDocuments.length === 0">
      <mat-icon>check</mat-icon>
      Confirm Selection ({{ selectedDocuments.length }})
    </button>
  </mat-dialog-actions>
</div>

